import { EOfficeType, Filters } from 'shared/types/filters';

export const includesBuildingType = (filters: Filters): boolean => {
  return filters.officeType.includes(EOfficeType.Building);
};
